<template>
  <div class="cover-singer-custom">
    <div class="cover-singer-custom-add flex-center pointer" @click="doAddCoverSinger">
      <i></i>
    </div>

    <div class="cover-singer-custom-label tc">custom</div>
  </div>
  <CoverSingerCustomDialog v-model:visible="renderData.addCoverSingerDialogVisible"></CoverSingerCustomDialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";
import CoverSingerCustomDialog from "./coverSingerCustomDialog.vue";

const Router = useRouter();
const route = useRoute();

const props = defineProps({});
const emits = defineEmits([]);
const renderData = reactive({
  addCoverSingerDialogVisible: false,
});

const doAddCoverSinger = () => {
  renderData.addCoverSingerDialogVisible = true;
}

onMounted(() => {

});
</script>
<style lang="scss">
.cover-singer-custom {
  width: 110px;
  .cover-singer-custom-add {
    height: 110px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    i {
      height: 20px;
      width: 20px;
      background: url("@/assets/img/editor/singer-add.png");
      background-size: 100%;

    }
    &:hover {
      background: rgba(255, 255, 255, 0.4);
    }
  }
  .cover-singer-custom-label {
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    margin: 12px auto 0;
  }
}
</style>
